export default "__VITE_ASSET__MauRIhUK__"